module.exports = __webpack_public_path__ + "img/confirma.c9e9560f.png";